/* @flow */

import * as React from 'react';
import { connect } from 'react-redux';

import styled from 'styled-components';

const CounterBox = styled.span`
  color: ${({ theme }) => theme.counterColor};
`;

const mapStateToProps = ({
  openOrders, marginOpenOrders, isLoggedIn,
}) => ({
  openOrders, marginOpenOrders, isLoggedIn,
});

type ComponentProps = {
  openOrders: Array<Object>,
  isLoggedIn?: boolean,
  marginOpenOrders: Array<any>,
  isMargin: boolean,
};


export default
@connect(mapStateToProps)
class OpenOrdersCounter extends React.Component<ComponentProps> {
  static defaultProps = {
    openOrders: [],
    marginOpenOrders: [],
    isLoggedIn: false,
    isMargin: false,
  }

  render() {
    const {
      openOrders,
      isLoggedIn,
      marginOpenOrders,
      isMargin,
    } = this.props;

    const length = isMargin ? marginOpenOrders.length : openOrders.length;
    return (
      <React.Fragment>
        {isLoggedIn &&
          <span> (<CounterBox>{length}</CounterBox>)</span>
        }
      </React.Fragment>
    );
  }
}
